const FieldMap = {
  exam_type: 'exam_description',
  raw_reasonforvisit: 'reason_for_visit',
  reasonforvisit: 'reason_for_visit',
  raw_body: 'body'
};

export { FieldMap };
